import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const TransitionMessage = ({ open, type, currentConsent, totalConsents, customDetails }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	
	if (!open) return null;

	return (
		<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(0, 0, 0, 0.5)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 9999,
			}}
		>
			<Box
				sx={{
					backgroundColor: isDark ? '#1e1e1e' : '#fff',
					padding: isMobile ? '2rem 1.5rem' : '2rem 2rem',
					borderRadius: customDetails?.borderRadius || '8px',
					boxShadow: isDark 
						? '0 8px 32px rgba(0, 0, 0, 0.6)' 
						: '0 8px 32px rgba(0, 0, 0, 0.3)',
					width: isMobile ? '90%' : '455px',
					maxWidth: isMobile ? '350px' : '455px',
					height: isMobile ? 'auto' : '243px',
					textAlign: 'center',
					border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e0e0e0',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					gap: isMobile ? '0.5rem' : '8px',
				}}
			>
				{/* Icon */}
				{type === 'approved' ? (
					<CheckCircleIcon 
						sx={{ 
							fontSize: isMobile ? '3rem' : '4rem', 
							color: customDetails?.successColor || '#4caf50',
							mb: 0,
						}} 
					/>
				) : (
					<CancelIcon 
						sx={{ 
							fontSize: isMobile ? '3rem' : '4rem', 
							color: customDetails?.errorColor || '#f44336',
							mb: 0,
						}} 
					/>
				)}
				
				{/* Progress */}
				<Typography
					sx={{
						fontSize: isMobile ? '0.75rem' : '0.875rem',
						color: isDark ? 'rgba(255, 255, 255, 0.7)' : '#666',
						mb: 0,
						fontWeight: 400,
					}}
				>
					Consent {currentConsent} of {totalConsents}
				</Typography>
				
				{/* Title */}
				<Typography
					sx={{
						fontSize: isMobile ? '1.25rem' : '1.5rem',
						fontWeight: 700,
						color: isDark ? '#fff' : '#000',
						mb: 0,
					}}
				>
					{type === 'approved' ? 'Consent Approved!' : 'Consent Rejected!'}
				</Typography>
				
				{/* Subtitle */}
				<Typography
					sx={{
						fontSize: isMobile ? '0.875rem' : '1rem',
						color: isDark ? 'rgba(255, 255, 255, 0.7)' : '#666',
						fontWeight: 400,
					}}
				>
					Please review the next consent...
				</Typography>
			</Box>
		</Box>
	);
};

export default TransitionMessage;
